import React from 'react';
import { appDocumentTitle } from '../../appMeta';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { PageShell } from '../../layout/PageShell';

export function MastersPage() {
  useDocumentTitle(appDocumentTitle('Master data'));

  return (
    <PageShell title="Master data" subtitle="Pilih master data dari menu kiri. Referensi ditampilkan sebagai menu terpisah per kode kategori.">
      <></>
    </PageShell>
  );
}
